import { render } from "./App.vue?vue&type=template&id=474aa642&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=474aa642&lang=scss"

import exportComponent from "/home/gitlab-deployer/builds/Bp7u02vYG/0/erp/vuejs-auth/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__